import { render, staticRenderFns } from "./energyReview.component.vue?vue&type=template&id=5d81d1b8&"
import script from "./energyReview.component.vue?vue&type=script&lang=js&"
export * from "./energyReview.component.vue?vue&type=script&lang=js&"
import style0 from "./energyReview.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports